import { AfterViewInit, Component, DestroyRef, inject, TemplateRef, ViewChild } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { AppDownloadService } from '@ftr/api-core'
import { ToastComponent, ToastService } from '@ftr/foundation'
import { WindowRefService } from '@ftr/window'
import { ActiveToast } from 'ngx-toastr'
import { combineLatest } from 'rxjs'
import { DesktopApiService } from '../../services/'

@Component({
  selector: 'ftr-update-app-toast',
  templateUrl: './update-app-toast.component.html',
  standalone: false,
})
export class UpdateAppToastComponent implements AfterViewInit {
  @ViewChild('updateReadyMessage') updateReadyMessage: TemplateRef<any>
  @ViewChild('updateRequiredMessage') updateRequiredMessage: TemplateRef<any>

  private currentToast: ActiveToast<ToastComponent> | undefined

  readonly #destroyRef = inject(DestroyRef)
  private readonly windowRefService = inject(WindowRefService)
  private readonly desktopApiService = inject(DesktopApiService)
  private readonly toastService = inject(ToastService)
  private readonly appDownloadService = inject(AppDownloadService)

  readonly downloadUrl = this.appDownloadService.getStandaloneAppLink()

  ngAfterViewInit(): void {
    combineLatest({
      updateRequired: this.desktopApiService.getUpdateRequiredAsObservable(),
      updateReady: this.desktopApiService.getUpdateReadyAsObservable(),
    })
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(({ updateRequired, updateReady }) => {
        if (this.currentToast) {
          this.currentToast.toastRef.close()
        }

        if (updateReady !== undefined) {
          this.currentToast = this.toastService.info(
            this.updateReadyMessage,
            updateReady ? 'Major Update Available' : 'Update Available',
            { disableTimeOut: true, hideClose: updateReady },
          )
          return
        }

        if (updateRequired) {
          this.currentToast = this.toastService.warning(this.updateRequiredMessage, 'Auto-Update Unavailable', {
            disableTimeOut: true,
          })
        }
      })
  }

  restartApp(toast: ToastComponent): void {
    this.currentToast = undefined
    this.windowRefService.getDesktopElectronApi()?.restartApp?.()
    toast.remove()
  }
}
